import _ from ".";

_.check("es5");

export default {};